/* eslint-disable sonarjs/no-duplicate-string */

import { Errors } from 'system/libs/Errors';

import { ToastNotify } from 'reactComponents/ToastNotify/ToastNotify';

define((require) => {
    'use strict';

    const $ = require('jQuery');
    const _ = require('lodash');
    const Emitter = require('Emitter');
    const StageInitial = require('../blocks/billing-registration/__stage-initial/billing-registration__stage-initial');
    const StageIndividual = require('../blocks/billing-registration/__stage-individual/billing-registration__stage-individual');
    const StageLegal = require('../blocks/billing-registration/__stage-legal/billing-registration__stage-legal');
    const StageThreeView = require('../blocks/billing-registration/__stage-legal-address/billing-registration__stage-legal-address');
    const StageFourView = require('../blocks/billing-registration/__stage-finish/billing-registration__stage-finish');
    const RegistrationModel = require('../models/Registration');
    const RegistrationStage = require('../models/RegistrationStage');
    const stageDefs = require('../models/RegistrationStage.defs');
    const defs = require('../models/Registration.defs');

    function Registration(model) {
        this._model = model || null;
        this._view = null;
        this._deferred = null;

        this._changeStageView = this._changeStageView.bind(this);

        this._innInputState = {
            start: 0,
            end: 0,
        };
    }

    Registration.fn = Registration.prototype = {
        constructor: Registration,

        _createModel() {
            if (!this._model) {
                this._model = new RegistrationModel({
                    id: 0,
                });
            }
        },

        _createStage() {
            const legalForm = this._model.get(defs.LEGAL_FORM);
            const attrs = {};

            if (legalForm === defs.TYPE_LEGAL) {
                attrs.currentStage = stageDefs.STAGE_LEGAL;
            } else if (legalForm === defs.TYPE_INDIVIDUAL) {
                attrs.currentStage = stageDefs.STAGE_INDIVIDUAL;
            }

            this._stage = new RegistrationStage(attrs);
        },

        _showCommonError() {
            ToastNotify.error(
                'Произошла ошибка регистрации. Попробуйте еще раз или обратитесь в нашу службу поддержки.',
            );
        },

        _chooseStageByField(field) {
            const legalForm = this._model.get(defs.LEGAL_FORM);

            if (field === defs.INN) {
                return stageDefs.STAGE_INITIAL;
            }

            // у ИП есть только один шаг формы
            if (legalForm === defs.TYPE_INDIVIDUAL) {
                return stageDefs.STAGE_INDIVIDUAL;
            }

            // у юр лица только два шага
            switch (field) {
                case defs.OGRN:
                case defs.KPP:
                case defs.LEGAL_NAME:
                case defs.PHONE:
                    return stageDefs.STAGE_LEGAL;

                default:
                    return stageDefs.STAGE_LEGAL_ADDRESS;
            }
        },

        _showRegistrationError(response) {
            let stage;
            let errors;
            const status = parseInt(response.get('status'), 10);
            const body = response.get('body');

            if (status === 400) {
                stage = this._chooseStageByField(body.key);
                errors = Errors.toBFormErrors(body);

                this._stage.toStage(stage);
                this._view.showErrors(errors);
            } else {
                this._showCommonError();
            }
        },

        _destroyCurrentView() {
            if (this._view) {
                this._view.close();
            }

            this._view = null;
        },

        close() {
            this._destroyCurrentView();

            if (this._deferred) {
                this._deferred.reject();
                this._deferred = null;
            }

            this._model = null;
        },

        _save() {
            return this._model.save();
        },

        _getViewByStage(stage) {
            switch (stage) {
                case stageDefs.STAGE_INITIAL:
                    return StageInitial;

                case stageDefs.STAGE_INDIVIDUAL:
                    return StageIndividual;

                case stageDefs.STAGE_LEGAL:
                    return StageLegal;

                case stageDefs.STAGE_LEGAL_ADDRESS:
                    return StageThreeView;

                case stageDefs.STAGE_FINISH:
                    return StageFourView;
            }
        },

        _getStageData(stage, data) {
            const stageData = {};

            switch (stage) {
                case stageDefs.STAGE_INITIAL:
                    stageData[defs.INN] = data[defs.INN];
                    break;

                case stageDefs.STAGE_INDIVIDUAL:
                    stageData[defs.OGRN] = data[defs.OGRN];
                    stageData[defs.LEGAL_NAME] = data[defs.LEGAL_NAME];
                    stageData[defs.PHONE] = data[defs.PHONE];
                    stageData[defs.PHYSICAL_ADDRESS] =
                        data[defs.PHYSICAL_ADDRESS];
                    break;

                case stageDefs.STAGE_LEGAL:
                    stageData[defs.OGRN] = data[defs.OGRN];
                    stageData[defs.KPP] = data[defs.KPP];
                    stageData[defs.LEGAL_NAME] = data[defs.LEGAL_NAME];
                    stageData[defs.PHONE] = data[defs.PHONE];
                    break;

                case stageDefs.STAGE_LEGAL_ADDRESS:
                    stageData[defs.LEGAL_POST] = data[defs.LEGAL_POST];
                    stageData[defs.LEGAL_CITY] = data[defs.LEGAL_CITY];
                    stageData[defs.LEGAL_STREET] = data[defs.LEGAL_STREET];
                    stageData[defs.LEGAL_HOUSE] = data[defs.LEGAL_HOUSE];
                    stageData[defs.LEGAL_REGION] = data[defs.LEGAL_REGION];
                    break;
            }

            return stageData;
        },

        _prepareSggestions(requisites) {
            const model = this._model;

            return _.map(requisites, (requisite) => {
                const data = model.prepareRequisite(requisite);

                return {
                    inn: data[defs.INN],
                    ogrn: data[defs.OGRN],
                    name: data[defs.LEGAL_NAME],
                    address: _([
                        data[defs.LEGAL_CITY],
                        data[defs.LEGAL_STREET],
                        data[defs.LEGAL_HOUSE],
                    ])
                        .compact()
                        .join(', '),
                };
            });
        },

        _saveStageData(data) {
            const stage = this._stage.get('currentStage');
            const stageData = this._getStageData(stage, data);

            this._model.set(stageData);
        },

        _showInnSuggest(suggestions) {
            const stage = this._stage.get('currentStage');

            if (stage === stageDefs.STAGE_INITIAL) {
                this._view.putSuggestData(suggestions);
            }
        },

        _chooseActionByResponseStatus(response) {
            const status = parseInt(response.get('status'), 10);

            if (status === 500) {
                this._chooseStageByLegalType();
            } else {
                this._showRegistrationError(response);
            }
        },

        _onInnChanged(event, field) {
            const innString = field.getValue();
            const isInnString =
                innString.length === 10 || innString.length === 12;
            const stage = this._stage.get('currentStage');
            const legalForm =
                innString.length === 10
                    ? defs.TYPE_LEGAL
                    : defs.TYPE_INDIVIDUAL;
            let requisitesRequest;

            this._innInputState = {
                start: _.get(field, 'input.el.selectionStart'),
                end: _.get(field, 'input.el.selectionEnd'),
            };

            this._model
                .reset()
                .set(defs.INN, innString)
                .set(defs.LEGAL_FORM, legalForm);

            if (stage !== stageDefs.STAGE_INITIAL) {
                this._stage.toPreviousStage();
            }

            if (isInnString) {
                requisitesRequest = this._model.fetchLegalRequisites();

                requisitesRequest
                    .then(this._prepareSggestions.bind(this))
                    .then(this._showInnSuggest.bind(this));

                requisitesRequest.catch(
                    this._chooseActionByResponseStatus.bind(this),
                );
            }
        },

        _onStageContinue(event, data) {
            this._saveStageData(data);
            this._stage.toNextStage();
        },

        _chooseStageByLegalType() {
            const legalType = this._model.getLegalType();

            if (legalType === defs.TYPE_LEGAL) {
                this._stage.toStage(stageDefs.STAGE_LEGAL);
            } else {
                this._stage.toStage(stageDefs.STAGE_INDIVIDUAL);
            }
        },

        _onLegalInfoSelected(event, data) {
            this._model.autofill(data);

            this._chooseStageByLegalType();
        },

        _onStageBack(event, data) {
            this._saveStageData(data);
            this._stage.toPreviousStage();
        },

        _onRegistrationCancel() {
            this.close();
        },

        _onRegistrationComplete(event, data) {
            const toNextStage = this._stage.toNextStage.bind(this._stage);
            const showRegistrationError = this._showRegistrationError.bind(
                this,
            );

            this._saveStageData(data);

            this._save()
                .then(toNextStage)
                .catch(showRegistrationError);
        },

        _getViewEventsByStage(stage) {
            switch (stage) {
                case stageDefs.STAGE_INITIAL:
                    return {
                        legalInfoSelected: this._onLegalInfoSelected.bind(this),
                        'change:inn': this._onInnChanged.bind(this),
                        cancel: this._onRegistrationCancel.bind(this),
                    };

                case stageDefs.STAGE_INDIVIDUAL:
                    return {
                        'change:inn': this._onInnChanged.bind(this),
                        complete: this._onRegistrationComplete.bind(this),
                        cancel: this._onRegistrationCancel.bind(this),
                    };

                case stageDefs.STAGE_LEGAL:
                    return {
                        continue: this._onStageContinue.bind(this),
                        'change:inn': this._onInnChanged.bind(this),
                        cancel: this._onRegistrationCancel.bind(this),
                    };

                case stageDefs.STAGE_LEGAL_ADDRESS:
                    return {
                        complete: this._onRegistrationComplete.bind(this),
                        back: this._onStageBack.bind(this),
                        cancel: this._onRegistrationCancel.bind(this),
                    };

                case stageDefs.STAGE_FINISH:
                    return {
                        cancel: this._onRegistrationCancel.bind(this),
                    };
            }
        },

        _changeStageView() {
            const stage = this._stage.get('currentStage');
            const data = this._model.toJSON();
            const StageView = this._getViewByStage(stage);
            const StageViewEvents = this._getViewEventsByStage(stage);

            this._destroyCurrentView();

            this._view = new StageView({
                el: $('<div/>').appendTo('.layers'),
                data,
                defs,
                innInputState: this._innInputState,
            });

            this._view.on(StageViewEvents);

            this._view.show();
        },

        _setListeners() {
            this._stage.on('change:currentStage', this._changeStageView);
        },

        start() {
            const deferred = {};
            const promise = new Promise((resolve, reject) => {
                deferred.resolve = resolve;
                deferred.reject = reject;
            });

            this._deferred = deferred;

            this._createModel();
            this._createStage();
            this._setListeners();

            this._changeStageView();

            return promise;
        },

        destroy() {
            this.close();
        },
    };

    Emitter.apply(Registration.fn);

    return Registration;
});
